
































































import { Component, Mixins, Provide } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import policyService from "@/services/policy.service"
import PageMixin from "@/mixins/page"
import { getColumns } from "./constant"
import { mapGetters } from "vuex"
import { asBlob } from "html-docx-js/dist/html-docx"
import { str2Html } from "@/utils"
import { saveAs } from "file-saver"
import config from "@/config"
import { getTimestamp } from "@/utils"
import DeployTimeModal from "../components/deploy-time.vue"
import RollbackModal from "../components/rollback-modal.vue"
import dayjs from "dayjs"
import { omit } from "lodash"
@Component({
    name: "PolicyList",
    components: {
        PageHeader,
        DeployTimeModal,
        RollbackModal
    },
    computed: {
        ...mapGetters(["currentUser", "isAdmin"]),
        ...mapGetters("common", [
            "product_type",
            "product_sub_type",
            "corporation",
            "top_dept",
            "software_list",
            "privacy_policy_text_type",
            "area",
            "privacy_policy_status",
            "preparation_status",
            "productSubTypeMap",
            "areaMap",
            "preparationStatusMap",
            "PolicyStatusMap",
            "syncWayMap",
            "textTypeMap"
        ])
    }
})
export default class PolicyList extends Mixins(PageMixin) {
    readonly software_list: any
    readonly privacy_policy_text_type: any
    readonly product_sub_type: any
    readonly area: any
    readonly privacy_policy_status: any
    readonly preparation_status: any
    readonly productSubTypeMap: any
    readonly areaMap: any
    readonly preparationStatusMap: any
    readonly syncWayMap: any
    readonly PolicyStatusMap: any
    readonly textTypeMap: any
    readonly currentUser: any
    readonly isAdmin: boolean

    @Provide()
    get useWrapperContext() {
        return this
    }

    loading = false
    pagination = {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showLessItems: true,
        size: "normal",
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        showTotal: (total: number) => `共${total}项`
    }
    get vPaginationBinds() {
        const exclude = ["showTotal"]
        return omit(this.pagination, exclude)
    }
    exportLoading = false
    setDeployTime = false
    deployForm: any = {
        id: undefined,
        deploy_time: undefined
    }
    setRollback = false
    rollbackForm: any = {
        id: undefined,
        preparation_status: undefined,
        target_preparation_status: undefined,
        reason: ""
    }
    dataSource: any = []
    id: number | string = undefined

    get softwareList() {
        return this.software_list.map((item: any) => {
            return {
                label: item.software_name,
                value: item.software_id
            }
        })
    }

    get columns() {
        return getColumns(this)
    }

    get currentUid() {
        return this.currentUser.uid
    }

    get tableActions() {
        return (record: any) => {
            const actions = [
                {
                    title: "编辑",
                    event: "edit",
                    enable: (record: any) => record.status === 1
                },
                {
                    title: "导出Word",
                    event: "exportWord",
                    enable: (record: any) => record.content
                },
                {
                    title: "部署上线",
                    event: "deploy",
                    enable: (record: any) =>
                        record.status === 3 &&
                        record.preparation_status === 3 &&
                        record.director === this.currentUid
                },
                {
                    title: "状态回退",
                    event: "rollbackStatus",
                    enable: (record: any) =>
                        this.isAdmin &&
                        record.status !== 4 &&
                        record.preparation_status !== 1
                }
            ]

            return actions.filter(item => (item.enable ? item.enable(record) : true))
        }
    }

    created() {
        this.id = Number(this.$route.query.id)
    }
    activated() {
        // 检查是否需要刷新数据
        this.getList()
    }
    mounted() {
        const product_sub_type = Number(this.$route.query.product_sub_type)
        const product_name = this.$route.query.product_name
        if (product_name && product_sub_type) {
            this.$nextTick(() => {
                ;(this.$refs.table as any).setFilters([
                    {
                        dataIndex: "product_name",
                        type: "input",
                        keyword: product_name
                    },
                    {
                        dataIndex: "product_sub_type",
                        type: "select",
                        keyword: [product_sub_type]
                    }
                ])
            })
        } else {
            this.getList()
        }
    }

    onView(record: any) {
        this.$router.push({
            path: "/policy/detail",
            query: {
                id: String(record.id)
            }
        })
    }

    onViewApply(records: any) {
        const { approval_id } = records[0] || {}
        if (!approval_id) {
            return
        }
        const url =
            config.env === "online"
                ? `https://home.intsig.net/process-centric/approval-detail?approval_id=${approval_id}`
                : `https://home-sandbox.intsig.net/process-centric/approval-detail?approval_id=${approval_id}`
        // window.location.href = url
        window.open(url)
    }

    onEdit(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/policy/edit",
            query: {
                id: String(record.id)
            }
        })
    }
    // 将html转成word
    async onExportWord(records: any[]) {
        const record = records[0]
        const fileData = str2Html(record.content, record.title)
        const docx = await asBlob(fileData)
        saveAs(docx, `${record.title}.docx`)
    }

    // onUploadHtml(records: any[]) {
    //     const record = records[0]
    //     const htmlContent = str2Html(record.content, record.title)
    //     const fileBlob = new Blob([htmlContent], { type: "text/html" })
    //     const formData = new FormData()
    //     formData.append("file", fileBlob)
    //     console.log(formData, "formData")
    //     policyService.uploadPolicy(formData)
    // }
    onDeploy(records: any[]) {
        // auto_deploy 1 自动部署 2非自动部署 0不能部署
        const { auto_deploy, id } = records[0]
        this.deployForm.id = id
        if (auto_deploy === 1) {
            this.deployForm.deploy_time = undefined
            this.deployPolicy()
        } else if (auto_deploy === 2) {
            this.setDeployTime = true
        } else {
            this.$info({
                title: "提示",
                content:
                    "当前隐私政策不满足部署条件，请联系管理员创建“产品与隐私政策相关对照”后再进行部署上线。"
            })
        }
    }

    delId() {
        this.id = undefined
        this.$router.push({
            path: "/policy/manage"
        })
        this.getList()
    }

    handleOk(time: number) {
        this.deployForm.deploy_time = time
        this.deployPolicy()
    }

    async deployPolicy() {
        try {
            const { deploy_time } = this.deployForm
            await policyService.deployPolicy({
                ...this.deployForm
            })
            this.getList()
            this.$message.success(
                `部署成功！${
                    deploy_time ? "当前隐私政策不是自动部署，还需自行更新隐私政策链接内容！" : ""
                }`
            )
            this.setDeployTime = false
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }

    onRollbackStatus(records: any[]) {
        const record = records[0]
        if (record.status === 4) {
            this.$message.warning("已部署状态不允许回退")
            return
        }
        if (record.preparation_status === 1) {
            this.$message.warning("法务编制中无需回退")
            return
        }
        this.rollbackForm.id = record.id
        this.rollbackForm.preparation_status = record.preparation_status
        this.setRollback = true
    }

    async submitRollback(payload: { target_preparation_status: number; reason: string }) {
        try {
            await policyService.rollbackPolicyStatus({
                id: this.rollbackForm.id,
                ...payload
            })
            this.$message.success("状态回退成功！")
            this.setRollback = false
            this.getList()
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }

    filterChange(filters: any[]) {
        this.filters = filters
        this.pagination.current = 1
        this.getList()
    }
    sortsChange(sorts: any[]) {
        this.sorts = sorts
        this.pagination.current = 1
        this.getList()
    }

    // 修复分页事件处理
    handlePageChange(page: number, pageSize: number) {
        this.pagination.current = page
        this.pagination.pageSize = pageSize
        this.getList()
    }

    handleShowSizeChange(current: number, size: number) {
        this.pagination.pageSize = size
        this.pagination.current = 1
        this.getList()
    }

    async getList() {
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const query: any = {}
        const timeKey = ["next_version_effective_time", "deploy_time", "apply_time"]
        this.filters.forEach((item: any) => {
            if (timeKey.includes(item.dataIndex)) {
                query[`${item.dataIndex}_start`] = item.keyword[0]
                    ? getTimestamp(dayjs(item.keyword[0]).format("YYYY-MM-DD 00:00:00"))
                    : undefined
                query[`${item.dataIndex}_end`] = item.keyword[1]
                    ? getTimestamp(dayjs(item.keyword[1]).format("YYYY-MM-DD 23:59:59"))
                    : undefined
            } else {
                let value = item.keyword
                if (item.dataIndex === "version_number" && value) {
                    value = Number(value)
                }
                query[item.dataIndex] = value
            }
        })
        this.sorts.forEach(item => {
            query[`${item.dataIndex}_sort`] = item.is_ascend ? 2 : 1
        })
        const payload = {
            offset,
            limit,
            id: this.id,
            ...query
        }
        try {
            const res = await policyService.getPolicyList(payload)
            const { total, list } = res
            this.dataSource = list || []
            this.pagination.total = total
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }

    handleExport() {
        this.exportLoading = true
        const query: any = {}
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const timeKey = ["next_version_effective_time", "deploy_time", "apply_time"]
        this.filters.forEach((item: any) => {
            if (timeKey.includes(item.dataIndex)) {
                query[`${item.dataIndex}_start`] = item.keyword[0] || ""
                query[`${item.dataIndex}_end`] = item.keyword[1] || ""
            } else {
                query[item.dataIndex] = item.keyword
            }
        })
        this.sorts.forEach(item => {
            query[`${item.dataIndex}_sort`] = item.is_ascend ? 2 : 1
        })

        const payload = {
            offset,
            limit,
            ...query
        }
        policyService
            .exportPolicy(payload)
            .catch(err => {
                this.$message.error(`${err}`)
            })
            .finally(() => {
                this.exportLoading = false
            })
    }
}
